import React from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import InputLabel from '@/components/form/base/InputLabel.tsx';
import BaseInput from '@/components/form/base/BaseInput.tsx';
import InputError from '@/components/form/base/InputError.tsx';
import InputHint from '@/components/form/base/InputHint.tsx';

export const NumberInput = ({
  label,
  register,
  placeholder,
  required = false,
  disabled = false,
  error,
  hint,
  min,
  max,
  step,
}: {
  label: string;
  register: UseFormRegisterReturn;
  placeholder: string;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  hint?: string;
  min?: number;
  max?: number;
  step?: number;
}) => {
  return (
    <div className="flex w-full flex-col items-start gap-1.5">
      <InputLabel label={label} required={required} disabled={disabled} />
      <input
        type="number"
        placeholder={placeholder}
        className={`w-full rounded-md border px-3 py-1.5 text-sm text-base-text ${
          disabled
            ? 'bg-basic-disabled-bg text-basic-disabled-main placeholder-basic-disabled-main'
            : 'placeholder-neutral-300'
        } ${error ? 'border-error-100' : 'border-neutral-200'}`}
        disabled={disabled}
        min={min}
        max={max}
        step={step}
        {...register}
      />
      <InputError error={error} />
      <InputHint hint={hint} />
    </div>
  );
};
